<template>
    <KLinkBlock
        v-if="links.length"
        v-editable="blok"
        :title="blok.title"
        :items="links"
        :link-as="NuxtLink"
        variant="subtle"
        @select="trackLink"
    />
</template>

<script setup>
import { KLinkBlock } from '@vemedia/karibu'
import { isExternalStoryblokLink, storyblokLinkHref } from '~~/shared/storyblok-link'

const { blok } = defineProps(['blok'])

const { capture } = useTracking()
const NuxtLink = resolveComponent('NuxtLink')
const links = computed(() => (blok.links || [])
    .map(item => ({
        label: item.text,
        href: storyblokLinkHref(item.link),
        external: isExternalStoryblokLink(item.link),
    }))
    .filter(item => item.label && item.href))

function trackLink({ item, index }) {
    capture('secondary_navigation_clicked', {
        placement: 'link-block',
        label: item.label,
        target_url: item.href,
        position: index + 1,
    })
}
</script>
